var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSurveyUpdateIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 35,
    cy: 35,
    r: 35,
    fill: "#FFEED1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.7157 27.0666L24.2397 25.0721C24.1082 24.4769 23.5667 24.0632 22.9579 24.0929C22.166 24.1307 21.6082 24.8853 21.8056 25.6531L23.0507 30.8093C23.2123 31.4786 23.8847 31.8912 24.5546 31.7322L29.7133 30.4967C31.3376 30.1027 30.7468 27.6664 29.1225 28.0603L26.642 28.6583C28.3592 26.4898 30.8898 24.9745 33.8637 24.657C39.7445 24.029 44.9935 28.2707 45.6215 34.1515C45.7566 35.8655 48.3452 35.5863 48.1117 33.8832C47.3885 27.1104 41.6231 22.067 34.2799 22.1365C29.969 22.5626 26.8353 24.4122 24.7157 27.0667V27.0666ZM40.2675 39.4664C38.5763 39.8127 39.1866 42.3588 40.851 41.9006L43.329 41.3024C41.6118 43.4702 39.0815 44.979 36.1073 45.2966C30.2266 45.9245 24.9799 41.6925 24.352 35.8117C24.2917 35.1571 23.7348 34.6609 23.0775 34.6764C22.3391 34.6953 21.778 35.3472 21.869 36.0803C22.6405 43.3045 29.1492 48.5607 36.3734 47.7892C40.0081 47.4014 43.1382 45.5456 45.2577 42.8943L45.7411 44.8913C46.0455 46.6396 48.6883 46.0068 48.1679 44.3102L46.9301 39.1516C46.7893 38.5565 46.2388 38.1506 45.5226 38.2104L40.2675 39.4664Z",
    fill: "#CC8000"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSurveyUpdateIcon);
export default __webpack_public_path__ + "static/media/surveyUpdateIcon.fbaa90bec5b714414c83b5e98ec28b1c.svg";
export { ForwardRef as ReactComponent };